<div class="row pg-style manage-elig-container">
  @if (showBlockingLoader()) {
  <rs-loader></rs-loader>
  }
  <div class="col-sm-12 pg-style">
    <div class="row search-banner">
      <div class="col-sm-12 search-banner-col">
        <h2 class="h3 search-banner-title">Manage Eligibility</h2>
      </div>
    </div>

    <div class="row search-nav">
      <div class="col-sm-12 search-nav-col">
        <ul class="list-inline search-nav-list">
          @if (manageEligFeatures().includes('member')) {
          <li>
            <a routerLink="/eligibility/member" (click)="forFlowsOtherThanMassActions('Member')" [class.search-nav-active]="subHeader() === 'Member'">Member</a>
          </li>
          }
          @if (manageEligFeatures().includes('addMember')) {
          <li>
            <a routerLink="/eligibility/add-member" (click)="forFlowsOtherThanMassActions('Add Member')" [class.search-nav-active]="subHeader() === 'Add Member'">Add Member</a>
          </li>
          }
          @if (manageEligFeatures().includes('enrollFamily')) {
          <li>
            <a routerLink="/eligibility/family-enrollment" (click)="forFlowsOtherThanMassActions('Family Enrollment')" [class.search-nav-active]="subHeader() === 'Family Enrollment'">Family Enrollment</a>
          </li>
          }
        </ul>
      </div>
    </div>

    <div class="row search-comp">
      <div class="card col-sm-12">
        @if (subHeader() === 'Member' && selectedAdminPlan()) {
          <elig-search [key]="'BMT'" [features]="$any(memberSearchFeatures)" [loaderImage]="''" [selectedAdminPlan]="selectedAdminPlan()"></elig-search>
          <elig-search-results [key]="'BMT'" [features]="$any(memberSearchResultFeatures)" [loaderImage]="''" [hideContentOnNoResults]="true" (resultSelected)="goToMemberDetails($event)"></elig-search-results>
        }

        @if (subHeader() !== 'Member' && selectedAdminPlan()) {
          @if (clientSearch.renderClientSearch()) {
          <bmt-client-search
            [attr.data-render-state]="clientSearch.clientSearchRenderState()"
            [selectedAdminPlan]="selectedAdminPlan()"
            (clientSelected)="clientSelected($event)"
            (subClientSelected)="subClientSelected($event)"
            (resetSelected)="clientSearchReset($event)"></bmt-client-search>
          }
        }

        @if (selectedSubClients().length > 0) {
          <div class="group-subgroup-heading">
            <div class="group-subgroup-content">
              <p><b>Group:</b> <span><b>{{ selectedSubClients()[0].planAcronym }}</b> {{ selectedSubClients()[0].client.name }} {{ selectedSubClients()[0].client.specifiedId }}</span></p>
              <p><b>Subgroup:</b> <span>{{ selectedSubClients()[0].name }} {{ selectedSubClients()[0].specifiedId }}</span></p>
            </div>
          </div>

          @if (subHeader() === 'Add Member') {
            @if (displayAddMemberForm()) {
            <ng-template [ngTemplateOutlet]="ssnForm"></ng-template>
            } @else if (!isFetchingUiAuth()) {
            <p style="color: red;">You are not authorized to add a member.</p>
            }
          }

          @if (subHeader() === 'Family Enrollment' && displayFamilyEnrollDefaultsForm()) {
            @if (contractResponse()) {
              <ng-template [ngTemplateOutlet]="familyEnrollmentDefaults"></ng-template>
              @if (showSsnFormForFamilyEnroll()) {
              <ng-template [ngTemplateOutlet]="ssnForm"></ng-template>
              }
            } @else if (!showContractLoader() && !isFetchingUiAuth()) {
            <p style="color: red;">Contract info is not available for the selected group and subgroup.</p>
            }
          }
        }
      </div>
    </div>
  </div>

  <ng-template #familyEnrollmentDefaults>
    @if (setDefaultsForm(); as defaultsForm) {
      <form [formGroup]="defaultsForm" (change)="handleDefaultsFormChange()" (ngSubmit)="setDefaultsForFamilyEnroll()" class="family-enorllment-defaults-form">
        <div class="defaults-for-family-enroll">
          <div>
            <rs-input label="Received Date" formControlName="receivedDate" type="date" strictDateTyping placeholder="MM/DD/YYYY"></rs-input>
            <rs-input label="Eligibility Effective Date" validation="eager" min="1900-01-01" formControlName="eligibilityEffectiveDate" type="date" strictDateTyping placeholder="MM/DD/YYYY"></rs-input>
            <rs-select autocomplete="off" [searchable]="true" [ariaRequired]="true" label="Eligibility Status" validation="eager" [items]="[{label: 'Active', value: 'active'}]" formControlName="eligibilityStatus"></rs-select>
            <rs-select label="Eligibility Status Reason" validation="eager" [items]="eligStatusReasons()" formControlName="eligibilityStatusReason"></rs-select>
          </div>
          <div>
            @if (qualifierTypes().length) {
            <rs-select autocomplete="off" [searchable]="true" [ariaRequired]="true" validation="eager" label="Qualifier Type" [items]="qualifierTypes()" formControlName="qualifierType"></rs-select>
            }
            @if (memberBenefitTypes().length) {
            <rs-select autocomplete="off" [searchable]="true" [ariaRequired]="true" validation="eager" label="Member Benefit Type" [items]="memberBenefitTypes()" formControlName="memberBenefitType"></rs-select>
            }
          </div>
        </div>
        <button [disabled]="!defaultsForm.valid || disableSetDefaults()" rs-raised-button color="primary">SET DEFAULTS</button>
      </form>
    }
  </ng-template>

  <!-- SSN form -->
  <ng-template #ssnForm>
    <div class="ssn-inputs">
      @if (memberIdEntryMode() !== 'system') {
        <h5>Specify Member</h5>
        @if (showCopyError()) {
        <p style="color: chocolate;"><code>Ctrl + C</code> / Copy is Not Allowed</p>
        }
        @if (addMemberForm(); as addMemberForm) {
          <form [formGroup]="addMemberForm" (ngSubmit)="navigateToAddMember()">
            <div>
              <rs-input label="Member ID" validation="eager" formControlName="ssn" (keydown.control.c)="onKeyPress($event)" [type]="changeType()" [placeholder]="'No dashes or spaces'"></rs-input>
              <rs-input label="Confirm Member ID" validation="eager" formControlName="confirmSsn" (keydown.control.c)="onKeyPress($event)" type="password" [placeholder]="'No dashes or spaces'"></rs-input>
              <button [disabled]="!addMemberForm.valid || isGeneratingPseudoSsn()" rs-raised-button color="primary">SUBMIT</button>
               @if (memberIdEntryMode() === 'both') {
                <button type="button" class="generate-pseudo-ssn-button" [disabled]="addMemberForm.valid || isGeneratingPseudoSsn()" (click)="generatePseudoSsn()" rs-raised-button color="primary">GENERATE PSEUDO SSN</button>
              }
            </div>
          </form>
        }
      }
      @if (isGeneratingPseudoSsn()) {
      <p>Generating pseudo SSN...</p>
      }
      @if (pseudoSsnError()) {
      <p style="color: red;">{{pseudoSsnError()}}</p>
      }
      @if (findMemberFeed()) {
      <elig-find-member [key]="'BMT'" [feed]="$any(findMemberFeed())" (foundMember)="foundMember($event)"></elig-find-member>
      }
    </div>
  </ng-template>
</div>
